'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (Component) {
  return Component.displayName || Component.name || 'Component';
};


// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/react-jss/lib/getDisplayName.js